import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw';
import 'github-markdown-css';
import 'highlight.js/styles/github.css';

const MarkdownContainer = styled.div`
  font-size: 14px;
`;

const processTextWithLineBreaks = text => {
  const lines = text.split('\n');

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </React.Fragment>
  ));
};

const renderChildrenWithLineBreaks = children => {
  return React.Children.map(children, child => {
    if (React.isValidElement(child) && child.props.children) {
      const grandChildren = React.Children.map(
        child.props.children,
        grandChild => {
          if (typeof grandChild === 'string') {
            return processTextWithLineBreaks(grandChild);
          }

          return grandChild;
        }
      );

      return React.cloneElement(child, {
        ...child.props,
        children: grandChildren
      });
    }

    return child;
  });
};

const components = {
  details: ({ node, ...props }) => {
    const children = renderChildrenWithLineBreaks(props.children);

    return <details {...props}>{children}</details>;
  }
};

export const Markdown = props => {
  const { markdownText } = props;

  return (
    <MarkdownContainer className='markdown-body'>
      <ReactMarkdown
        children={markdownText}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeHighlight]}
        components={components}
      />
    </MarkdownContainer>
  );
};

export default Markdown;
